import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '../../../environments/environment';
import { PushNotification } from '../models/push-notification';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable()
export class SignalRService {
  // private hubConnection: signalR.HubConnection;

  constructor(
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private authentication: AuthenticationService) { }

  public startConnection() {
    // this.hubConnection = new signalR.HubConnectionBuilder()
    //                         .withUrl(`${environment.apiBaseUrl}/notification`, { accessTokenFactory: () => {
    //                           const token = this.authentication.getToken();
    //                           return token;
    //                         }})
    //                         .build();

    // this.hubConnection
    //   .start()
    //   .then(() => console.log('Connection started'))
    //   .catch(err => console.log('Error while starting connection: ' + err));
  }

  public addPushNotificationListener() {
    // this.hubConnection.on('PushNotification', (response: PushNotification) => {
    //   this.translateService.get(response.messageKey).subscribe(translation => {
    //     this.toastrService.warning(`${translation} ${response.requestNumber}`, '', {
    //     });
    //   });
    // });
  }
}
